import React, { useState } from 'react'
import { Button, Table, FormControl } from 'react-bootstrap'
import { IosSwitch } from '@CommonComponents'
import { client } from '../utils'
import { symphonyServices as endpoints } from '../api_urls'
import ButterToast, { Cinnamon, POS_TOP, POS_RIGHT } from 'butter-toast'
import PropTypes from 'prop-types'

/* jshint ignore:start */
const App = props => {
  const [assessmentDeliveryService, toggleAssessmentDeliveryService] = useState(
    props.assessmentDelivery
  )
  const [busy, setBusy] = useState(false)
  const [titlesUpdated, setTitlesUpdated] = useState(null)
  const [symphonyData, setSymphonyData] = useState(props.symphonyData)
  const [isDirty, setDirty] = useState(false)

  return (
    <React.Fragment>
      <ButterToast
        position={{ vertical: POS_TOP, horizontal: POS_RIGHT }}
        style={{ top: '65px' }}
      />
      <h3>Symphony Services</h3>
      <Table size="sm" className="m-0">
        <tbody>
          <tr>
            <td>Power up to Symphony</td>
            <td>
              <Button
                type="button"
                bsStyle="default"
                size="sm"
                className="btn-myed btn-default-myed btn-sm-myed"
                disabled={!assessmentDeliveryService || busy}
                onClick={async () => {
                  setBusy(true)
                  try {
                    const resp = await client.post(
                      endpoints.pushCourseAssessmentsToSymphony(),
                      {}
                    )
                    setTitlesUpdated(resp.data.titles)
                  } catch (err) {
                    setTitlesUpdated(null)
                    ButterToast.raise({
                      content: (
                        <Cinnamon.Crunch
                          title="Error"
                          content={`There was an error pushing the assessments. ${err}`}
                          scheme={Cinnamon.Crisp.SCHEME_RED}
                          icon={
                            <i className="far fa-exclamation-triangle fa-3x" />
                          }
                        />
                      ),
                    })
                  } finally {
                    setBusy(false)
                  }
                }}
              >
                {busy && <i className="far fa-spinner-third fa-spin mr-3" />}
                Push Assessments
              </Button>
              {titlesUpdated && (
                <ul>
                  {titlesUpdated.map((title, idx) => (
                    <li key={idx} className="text-muted">
                      {title}
                    </li>
                  ))}
                </ul>
              )}
            </td>
            <td>
              <label>
                <span className="hide">Power up to Symphony</span>
                <IosSwitch
                  onChange={() => {
                    let data = {
                      symphony_assessment_delivery: !assessmentDeliveryService,
                    }
                    client
                      .post(endpoints.updateAssessmentDeliveryService(), data)
                      .then(() => {
                        toggleAssessmentDeliveryService(
                          !assessmentDeliveryService
                        )
                      })
                      .catch(err => {
                        ButterToast.raise({
                          content: (
                            <Cinnamon.Crunch
                              title="Error"
                              content={`There was an error trying to toggle the service. ${err}`}
                              scheme={Cinnamon.Crisp.SCHEME_RED}
                              icon={
                                <i className="far fa-exclamation-triangle fa-3x" />
                              }
                            />
                          ),
                        })
                      })
                  }}
                  checked={assessmentDeliveryService}
                  disabled={busy}
                />
              </label>
            </td>
          </tr>

          <tr>
            <td>Symphony reader</td>
            <td>
              <Button
                type="button"
                bsStyle="default"
                size="sm"
                className="btn-myed btn-default-myed btn-sm-myed"
                disabled={busy}
                onClick={() => {
                  setBusy(true)
                  try {
                    client
                      .post(endpoints.pushCourseContentToSymphony())
                      .then(() => {
                        ButterToast.raise({
                          content: (
                            <Cinnamon.Crunch
                              title="Success"
                              content={'Successfully posted to Symphony'}
                              scheme={Cinnamon.Crisp.SCHEME_GREEN}
                              icon={<i className="far fa-thumbs-up fa-3x" />}
                            />
                          ),
                        })
                      })
                  } catch (err) {
                    const msg =
                      err.response &&
                      err.response.data &&
                      err.response.data.error
                    console.log(err.response)
                    ButterToast.raise({
                      content: (
                        <Cinnamon.Crunch
                          title="Error"
                          content={msg || err.toString()}
                          scheme={Cinnamon.Crisp.SCHEME_RED}
                          icon={
                            <i className="far fa-exclamation-triangle fa-3x" />
                          }
                        />
                      ),
                    })
                  } finally {
                    setBusy(false)
                  }
                }}
              >
                Push Content
              </Button>
            </td>
            <td>
              <label>
                <span className="hide">Use Symphony reader</span>
                <IosSwitch
                  onChange={() => {
                    alert(
                      "Who told you to toggle that switch? Did I tell you to toggle that switch? I never said toggle the switch! That switch is preposterous, inconceivable, unconscionable. You're flipping switches willy-nilly without a care in the world. Switches are not playthings! This is switch-toggling negligence of the most flagrant variety!"
                    )
                  }}
                />
              </label>
            </td>
          </tr>
          <tr>
            <td colSpan="3" className="">
              <div className="mb-4">
                <div className="float-right">
                  <Button
                    type="button"
                    bsStyle="default"
                    size="sm"
                    className="btn-myed btn-success-myed btn-sm-myed text-white"
                    disabled={!isDirty || busy}
                    onClick={async () => {
                      setBusy(true)
                      try {
                        const resp = await client.post(
                          endpoints.updateSymphonyData(),
                          {
                            symphony_data: symphonyData,
                          }
                        )
                        setDirty(false)
                        setSymphonyData(resp.data.symphony_data)
                      } catch (err) {
                        const msg =
                          err.response &&
                          err.response.data &&
                          err.response.data.error
                        ButterToast.raise({
                          content: (
                            <Cinnamon.Crunch
                              title="Error"
                              content={msg || err.toString()}
                              scheme={Cinnamon.Crisp.SCHEME_RED}
                              icon={
                                <i className="far fa-exclamation-triangle fa-3x" />
                              }
                            />
                          ),
                        })
                      } finally {
                        setBusy(false)
                      }
                    }}
                  >
                    Save
                  </Button>
                </div>
                <div className="mt-2">Configuration (yaml):</div>
              </div>
              <label htmlFor="config-yaml" className="hidden_label">
                Configuration YAML
              </label>
              <FormControl
                id="config-yaml"
                componentClass="textarea"
                style={{
                  minHeight: '180px',
                }}
                value={symphonyData}
                onChange={async e => {
                  setDirty(true)
                  setSymphonyData(e.target.value)
                }}
              />
            </td>
          </tr>
        </tbody>
      </Table>
    </React.Fragment>
  )
}

App.propTypes = {
  assessmentDelivery: PropTypes.bool.isRequired,
  symphonyData: PropTypes.string.isRequired,
}

export default App
